import { TextField } from "@mui/material";
import { useEffect, useRef } from "react";

const getTextWidth = (text, font = "14px Arial") => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  context.font = font;
  return context.measureText(text).width + 32;
};

const AutoResizeTextField = ({ inputId, value, onChange }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      const width = getTextWidth(value || " ");
      inputRef.current.style.width = `${width}px`;
    }
  }, [value]);

  return (
    <TextField
      key={inputId}
      id={inputId}
      disabled
      inputRef={inputRef}
      variant="filled"
      color="primary"
      focused
      size="small"
      value={value}
      // onChange={(e) => onChange(inputId, e.target.value)}
      sx={{
        mx: 1,
        width: "fit-content",
        display: "inline-block",
        verticalAlign: "middle",
        "& .MuiFilledInput-root": {
          backgroundColor: value ? "#f0f9ff" : "#f8fafc",
          "&:hover": { backgroundColor: "#f1f5f9" },
          "&.Mui-focused": { backgroundColor: "#ffffff" },
        },
        "& .MuiFilledInput-input": {
          padding: "0px 16px",
          fontSize: "14px",
          width: "auto",
          my: 0.5,
        },
        "& .MuiInputLabel-root": {
          fontSize: "12px",
        },
      }}
    />
  );
};

export default AutoResizeTextField;
